import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import cx from 'classnames';
import React from 'react';
export var SiteFooter = function SiteFooter(_ref) {
  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["align", "children", "className"]);

  return React.createElement("footer", _objectSpread({
    className: cx('tds-site-footer', {
      'tds-site-footer--align_start': align === 'start'
    }, className)
  }, rest), React.createElement("nav", {
    className: "tds-footer-nav"
  }, React.createElement("ul", {
    className: "tds-list tds-list--horizontal"
  }, React.Children.map(children, function (child) {
    return child ? React.createElement("li", {
      className: "tds-footer-item"
    }, child) : null;
  }))));
};